// "Konu Anlatımına Git" confirm modal — the ONE gate between a weak outcome and /learning-path.
// Shared by both report tabs: the Güçlü/zayıf cards and the Genel durum outcome rows. Was born
// inside OutcomeGraphStrongWeakStyles as `qbe-modal-*`; it moved out (unchanged, prefix renamed)
// when Genel durum needed the same modal, so there is one dialog to keep consistent, not two.
// Prefix: sdn-
export const subjectDescriptionNavigationModalStyles = `
  .sdn-body {
    display: flex;
    flex-direction: column;
    row-gap: var(--space-4);
    padding: var(--space-2) var(--space-2) 0;
  }

  /* Target outcome preview — frosted brand strip with name + score tier */
  .sdn-outcome {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-4);
    padding: var(--space-3) var(--space-4);
    border-radius: var(--rad-catchup-medium);
    background: var(--brand-50);
    border: 1px solid var(--brand-100);
    border-left: 4px solid var(--brand);
  }
  .sdn-outcome-main {
    min-width: 0;
  }
  .sdn-outcome-label {
    display: block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--text-muted);
    margin-bottom: 2px;
  }
  .sdn-outcome-name {
    font-size: var(--fs-base);
    font-weight: 600;
    color: var(--brand-darker);
    line-height: 1.4;
  }
  .sdn-score {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 62px;
    padding: var(--space-2) var(--space-3);
    border-radius: var(--rad-catchup-medium);
  }
  .sdn-score-value {
    font-size: var(--fs-xl);
    font-weight: 800;
    line-height: 1;
  }
  .sdn-score-label {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    margin-top: 3px;
  }
  .sdn-score--low {
    background: var(--color-error-bg);
  }
  .sdn-score--low .sdn-score-value {
    color: var(--color-error);
  }
  .sdn-score--low .sdn-score-label {
    color: var(--color-error-text);
  }
  .sdn-score--mid {
    background: var(--accent-gold-bg);
  }
  .sdn-score--mid .sdn-score-value {
    color: var(--accent-gold);
  }
  .sdn-score--mid .sdn-score-label {
    color: var(--accent-gold-text);
  }
  .sdn-score--high {
    background: var(--accent-lime-bg);
  }
  .sdn-score--high .sdn-score-value {
    color: var(--accent-lime-text);
  }
  .sdn-score--high .sdn-score-label {
    color: var(--accent-lime-text);
  }
  .sdn-text {
    text-align: center;
    color: var(--text-secondary);
    font-size: var(--fs-base);
    line-height: 1.55;
  }
  .sdn-actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: var(--space-3);
    width: 100%;
    margin-top: var(--space-4);
  }
`;
